import { PlantsContainer } from '@modules/plants/containers/plants_container';
import { Plants } from '@modules/plants/views/plants_view';
import { useCallback } from 'react';
import { toast } from 'sonner';

export function PlantsScreen() {
  const onError = useCallback((message: string) => {
    toast.error(message);
  }, []);

  return <PlantsContainer View={Plants} onError={onError} />;
}
